

























































import {Component, Vue, Prop, Emit} from 'vue-property-decorator'
import {
  DxPopup, DxScrollView, DxButton
} from 'devextreme-vue';

import DButton from '@/components/DButton/button.vue';
import {fitPopupHeight, fitPopupWidth} from '@/utils/fitPopup';


@Component({
  name: 'DEditPopup',
  components: {
    DxPopup,
    DxScrollView,
    DxButton,
  }
})
export default class extends Vue {

  @Prop({default: ''}) public title!: string;
  @Prop({required: true}) public visible!: boolean;
  @Prop({default: undefined}) public defaultWidth!: number;
  @Prop({default: undefined}) public defaultHeight!: number;
  @Prop({default: 'Сохранить'}) public okButtonCaption!: string;
  @Prop({default: 'Отменить'}) public cancelButtonCaption!: string;
  @Prop({default: true}) public showOkButton!: boolean;
  @Prop({default: false}) public disableOkButton!: boolean;
  @Prop({default: ''}) public cssClass!: string;
  @Prop({ default: '' }) public validationGroup!: string;


  public empty() {

  }

  public fitPopupWidth() {
    return fitPopupWidth(this.defaultWidth);
  }

  public fitPopupHeight() {
    return fitPopupHeight(this.defaultHeight);
  }

  @Emit('shown')
  onShow() {
  }

  @Emit('showing')
  onShowing() {
  }

  @Emit('hidden')
  onClose() {
  }

  @Emit('ok')
  onOk(e: any): any {
    return e;
  }

  @Emit('cancel')
  onCancel(e: any): any {
    return e;
  }
}
